import {z} from 'zod';

export const MarketingCodeFormSchema = z.object({
  warehouseId: z.string(),
  name: z.string(),
  externalCode: z.string(),
  salesBasePriceMarkup: z.number().nullish(),
  warrantyPriceMarkup: z.number().nullish(),
});

export type MarketingCodeForm = z.infer<typeof MarketingCodeFormSchema>;
